const home = [{
    path: '/',
    name: 'home',
    meta: {
        auth: false,
    },
    component: () => {
        return import(/* webpackChunkName: "Home" */ '@/views/Home')        
    }
        
}]

export {home}